import { Certidao } from "./certidao";

export interface CertidoesAnoJson {
  CodProtocolo?: number;
  Exercicio?: number;
  NrProcesso?: string;
  ItensAnalisados?: Certidao[];
}

export class CertidoesAno {
  CodProtocolo?: number;
  Exercicio?: number;
  NrProcesso?: string;
  ItensAnalisados: Certidao[] = [];
  pendencias?: number;

  //usado para passar info entre componentes
  codUG?: string;

  constructor(obj?: CertidoesAnoJson) {
    if (obj) {
      this.CodProtocolo = obj.CodProtocolo;
      this.Exercicio = obj.Exercicio;
      this.NrProcesso = obj.NrProcesso;
      this.pendencias = 0;
      this.ItensAnalisados =
        obj.ItensAnalisados?.map((i) => new Certidao(i)) || [];
    }
  }

  get titulo(): string {
    return `${this.Exercicio}${
      this.NrProcesso ? ": " + this.NrProcesso : " (sem processo)"
    }`;
  }
}
